import { render, staticRenderFns } from "./PaksitanClientInvoiceTemplate.vue?vue&type=template&id=77b962a4&"
import script from "./PaksitanClientInvoiceTemplate.vue?vue&type=script&lang=js&"
export * from "./PaksitanClientInvoiceTemplate.vue?vue&type=script&lang=js&"
import style0 from "./PaksitanClientInvoiceTemplate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports